import script from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"

import "./AboutUs.vue?vue&type=style&index=0&id=3275df5f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3275df5f"]])

export default __exports__